import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { BaseModalComponent } from '../../../models/base-modal-component';
import { HelpIndex } from '../../../models/enums';
import { CommonService } from '../../../services/common/common.service';
import { RestService } from '../../../services/rest/rest.service';

export interface GenerateDataSetReportModalData {
    viewHandle?: string;
}

export interface ReportSetting {
    value: string;
    label: string;
}

@Component({
    standalone: false,
    selector: 'res-generate-data-set-report-modal',
    templateUrl: './generate-data-set-report-modal.component.html',
    styleUrls: ['./generate-data-set-report-modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class GenerateDataSetReportModalComponent extends BaseModalComponent implements OnInit {
    automationId = 'generate-data-set-report';
    modalClass = 'generate-data-set-report-modal';
    modalHelpIndex = HelpIndex.generate_data_set_report_dlg;
    isBusy = false;
    isBusyMessage = 'Generating report...';

    reportSettings: ReportSetting[] = [
        { value: 'current', label: 'Current Project Settings' }
    ];
    selectedReportSetting = 'current';
    combineWarningsAndErrors = true;
    includeZeroCountRows = false;
    includePercentages = false;

    generateDataSetReportModalData: GenerateDataSetReportModalData;

    constructor(
        private modalService: BsModalService,
        private modalRef: BsModalRef,
        private commonService: CommonService,
        private restService: RestService
    ) {
        super(modalService, modalRef);
    }

    ngOnInit(): void {
        this.generateDataSetReportModalData = this.modalData as GenerateDataSetReportModalData;
    }

    generateReport(): void {
        // TODO: Implement the actual report generation logic
        this.isBusy = true;
        this.isBusyMessage = 'Generating report...';

        // Placeholder for actual API call
        const reportOptions = {
            reportSetting: this.selectedReportSetting,
            combineWarningsAndErrors: this.combineWarningsAndErrors,
            includeZeroCountRows: this.includeZeroCountRows,
            includePercentages: this.includePercentages,
            viewHandle: this.generateDataSetReportModalData?.viewHandle
        };

        console.log('Generate Data Set Report with options:', reportOptions);

        // Simulate API call completion
        setTimeout(() => {
            this.isBusy = false;
            this.closeModal();
        }, 1000);
    }
}
